import styled from "@emotion/styled"

// Components
import { H3 } from "../../ComponentLibrary/text-elements/oc-h";

const TitleContainer = styled.div`
  display: inline-flex;
  margin-bottom: 1em;
  position: relative;
  width: 100%;
`;

const Logo = styled.div`
  background-image: url("//dcpd6wotaa0mb.cloudfront.net/owenscorning.com/assets/roofing/oc-logo-8a618413fbb8004fd179746dedda8755aea61e6308a58c973a24d38bdf389616.svg");
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  height: 62px;
  margin-right: 12px;
  position: relative;
  width: 62px;
`;

const TitleWrap = styled.div`
  display: inline-flex;
  flex-direction: column;
  position: relative;
  width: calc(100% - 75px);
`;

const PreTitle = styled.div`
  color: #585858;
  font-family: "OCRoboto";
  letter-spacing: 0.01em;
  line-height: 1.125em;
  margin-bottom: 7px;
`;

const Title = styled(H3)`
  border-bottom: 2px solid;
  padding-bottom: 0.15em;
`;

const ShingleColorTitle = ({ colorName, shingleName }) => {
  return (
    <TitleContainer>
      <Logo />
      <TitleWrap>
        <PreTitle dangerouslySetInnerHTML={{ __html: `${shingleName} Shingles` }} />
        <Title>{colorName}</Title>
      </TitleWrap>
    </TitleContainer>
  );
};

export default ShingleColorTitle;
